import React from 'react';

import {IconButton} from '#Client/components/IconButton/IconButton';
import {errorMessage} from '#Client/components/SiteUnavailable/SiteUnavailable.css';

const reload = () => {
  location.reload();
};
export const SiteUnavailable = () => (
  <div className={errorMessage}>
    <div>
      <h3>Word Crunch is Temporarily Unavailable</h3>
      <p>
        Sorry about that! We&apos;ll be back up and running as soon as possible.
      </p>
      <p>Please click to try again.</p>
    </div>
    <div className="textAlignCenter">
      <IconButton
        icon="btn_icon_reload.png"
        large
        text="Reload"
        onClick={reload}
      />
    </div>
  </div>
);
